import React, { useState, useRef } from 'react';
import { X, Link as LinkIcon, Upload } from 'lucide-react';
import { authAxios } from '@/lib/api';

export default function BrochureUpload({ url, onChange }) {
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);

  const handleFile = async (file) => {
    if (!file) return;
    setUploading(true);
    const fd = new FormData();
    fd.append('file', file);
    try {
      const { data } = await authAxios.post('/api/upload', fd);
      onChange(data.url);
    } catch {
      alert('Upload failed');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div data-testid="brochure-section">
      <label className="text-[10px] uppercase tracking-wider text-earth/50 font-sans font-semibold mb-2 block">Product Brochure (PDF)</label>
      {url ? (
        <div className="flex items-center gap-2 bg-cream/40 rounded-lg px-3 py-2.5 border border-earth/8">
          <div className="w-8 h-8 rounded bg-chilli/10 flex items-center justify-center"><LinkIcon size={14} className="text-chilli" /></div>
          <span className="text-xs font-sans text-earth-dark flex-1 truncate">{url.split('/').pop()}</span>
          <a href={url} target="_blank" rel="noopener noreferrer" className="text-[10px] text-saffron font-sans font-semibold hover:underline" data-testid="brochure-preview">Preview</a>
          <button onClick={() => onChange('')} className="text-chilli/40 hover:text-chilli" data-testid="brochure-remove"><X size={12} /></button>
        </div>
      ) : (
        <div className="border-2 border-dashed rounded-lg p-3 text-center border-earth/15 hover:border-saffron/30 transition-colors">
          <input ref={fileRef} type="file" accept=".pdf" className="hidden" onChange={(e) => handleFile(e.target.files[0])} data-testid="brochure-file-input" />
          <button type="button" onClick={() => fileRef.current?.click()} disabled={uploading} className="text-xs font-sans text-saffron hover:text-saffron-dark flex items-center gap-1.5 mx-auto" data-testid="brochure-upload-btn">
            <Upload size={13} /> {uploading ? 'Uploading...' : 'Upload PDF Brochure'}
          </button>
          <p className="text-[10px] text-earth/30 font-sans mt-1">Buyers can download this from the product page</p>
        </div>
      )}
    </div>
  );
}
